import {
  CUSTOMER_REVIEW_FETCHING,
  CUSTOMER_REVIEW_LIST_FETCH,
  CUSTOMER_REVIEW_DETAIL_FETCH,
  CUSTOMER_REVIEW_ERROR,
  CUSTOMER_REVIEW_ERROR_DISMISS
} from '../constants';

import { FETCH_DETAIL_REQ, MODERATE_REQ } from '../actions/customerReviewAction';

const initialState = {
  list: {
    data: [],
    status_code: null
  },
  isFetch: false,
  hasRequested: false,
  error: null,
  detail: {
    data: {},
    isFetch: false,
    isSubmit: false,
    error: null,
  },
};

// Detail-side transitions (create/detail/moderate flows)
const onProgress = (lastState, { requestType, bool }) => {
  switch (requestType) {
    case FETCH_DETAIL_REQ: {
      const { detail } = lastState;
      return { ...lastState, detail: { ...detail, isFetch: bool, error: bool ? null : detail.error } };
    }
    case MODERATE_REQ: {
      const { detail } = lastState;
      return { ...lastState, detail: { ...detail, isSubmit: bool } };
    }
    default: return lastState;
  }
};

const onError = (lastState, { requestType, error, id }) => {
  switch (requestType) {
    case FETCH_DETAIL_REQ: {
      const { detail } = lastState;
      return { ...lastState, detail: { ...detail, error: { ...error, id } } };
    }
    default: return lastState;
  }
};

const onDetailFetched = (lastState, payload) => {
  const { detail } = lastState;
  const { data, message, status_code } = payload;
  return { ...lastState, detail: { ...detail, data, message, status_code, error: null } };
};

// List-side transitions
const onListFetch = (lastState, payload) => ({ ...lastState, list: payload, error: null });
const onListFetching = (lastState, payload) => ({
  ...lastState,
  isFetch: payload.status,
  hasRequested: payload.status ? true : lastState.hasRequested
});
const onListError = (lastState, payload) => ({ ...lastState, error: payload });

const customerReviewReducer = (state = initialState, action) => {
  switch (action.type) {
    case CUSTOMER_REVIEW_LIST_FETCH:
      return onListFetch(state, action.payload);
    case CUSTOMER_REVIEW_DETAIL_FETCH:
      return onDetailFetched(state, action.payload);
    case CUSTOMER_REVIEW_FETCHING:
      return action.payload && action.payload.requestType
        ? onProgress(state, action.payload)
        : onListFetching(state, action.payload);
    case CUSTOMER_REVIEW_ERROR:
      return action.payload && action.payload.requestType
        ? onError(state, action.payload)
        : onListError(state, action.payload);
    case CUSTOMER_REVIEW_ERROR_DISMISS:
      return { ...state, error: null };
    default:
      return state;
  }
};

export default customerReviewReducer;
